import styled from 'styled-components';

export const ArticlePreviewContainer = styled.div`
	height: 100%;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[4]};
	border-radius: 0.25rem;
	padding: 1rem;
	cursor: pointer;
	transition: background 0.3s ease;

	&:hover {
		background: ${({ theme }) => theme.v3.colors.gray[0]};
	}

	.category {
		margin-bottom: 2.5rem;
	}

	.title {
		margin-bottom: 0.5rem;
	}

	.meta {
		margin-bottom: 0.5rem;
		color: ${({ theme }) => theme.v3.colors.dark[0]};
	}

	.author {
		transition: color 0.3s ease;

		&:hover {
			color: ${({ theme }) => theme.v3.colors.dark[8]};
			text-decoration: underline;
		}
	}

	.rich-text {
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		text-overflow: ellipsis;
	}
`;
